import {Injectable} from "@angular/core";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {AttributeValueResponse} from "../models/attributeValueResponse";

@Injectable({
  providedIn: "root"
})
export class AttributeValueService {

  private readonly ENDPOINT_URL = `${environment.apiUrl}/products/attribute-values`;

  constructor(private http: HttpClient) {
  }

  getAll(): Observable<Array<AttributeValueResponse>> {
    return this.http.get<Array<AttributeValueResponse>>(this.ENDPOINT_URL);
  }

}
